export const DEFAULT_VIDEO_URL = 'https://download.blender.org/durian/trailer/sintel_trailer-480p.mp4';
export const TIME_PRECISION = 6;
export const LOCAL_STORAGE_CLIPS_KEY = 'videoSlicerClips';
